import styled from 'styled-components'
import eyeIcon from '../../../assets/images/password_eye.svg'
import eyeIconHide from '../../../assets/images/password_eye_hide.svg'
import { EDirection } from 'types/enums/ELanguage'

export const ShowPasswordButton = styled.button<{ direction: EDirection }>`
  position: absolute;
  ${({ direction }) => (direction === EDirection.RTL ? 'left' : 'right')}: 1px;
  top: 11px;
  height: calc(100% - 4px);
  width: 40px;
  border-radius: 0;
  border: none;
  background: none;
  z-index: 1;

  &:focus-visible {
    outline: none;
  }

  i {
    display: block;
    height: 100%;
    width: 100%;
    cursor: pointer;

    &.password-eye {
      background: url(${eyeIcon});
      background-position: center;
      background-repeat: no-repeat;
    }

    &.password-eye-hide {
      background: url(${eyeIconHide});
      background-position: center;
      background-repeat: no-repeat;
    }
  }
`
